import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditPrivilegesReady} from '../redux/privileges'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'
//import * as Helpers from '../../../common/helpers'

class AddEditPrivileges extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        privilegeName: "",
        privilegeAppAccess: "",
        privilegeApiAccess: "",
        privilegeRemarks: "",

        selectedRoles: [],
        privilegesData: [],
        rolesList: [],
        deletedRoles:[],


        privilegeNameErrorText: false,
        privilegeNameErrorData: '',

        privilegeAppAccessErrorText: false,
        privilegeAppAccessErrorData: '',

        privilegeApiAccessErrorText: false,
        privilegeApiAccessErrorData: '',

        privilegeRemarksText: false,
        privilegeRemarksData: '',

        subTitle: Constants.ADD_PRIVILEGES

    }

    this.isComponentStillMounted = true

    this.privilegeNameComponent = null
    this.privilegeNameSection = null

    this.privilegeAppAccessComponent = null
    this.privilegeAppAccessSection = null

    this.privilegeApiAccessComponent = null
    this.privilegeApiAccessSection = null

    this.privilegeRemarksComponent = null
    this.privilegeRemarksSection = null

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditPrivilegesReady(false))

    if (this.props.privileges && this.props.privileges.privilegeSelectedId && this.props.privileges.privilegeSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_PRIVILEGES))
        this.setState({
            subTitle: Constants.EDIT_PRIVILEGES,
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_PRIVILEGES))
        this.setState({
            subTitle: Constants.ADD_PRIVILEGES
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()

    this.getRolesComboList()

   
}

componentDidMount() {

        this.privilegeNameSection = ReactDOM.findDOMNode(this.refs.privilegeNameSection)
        this.privilegeAppAccessSection = ReactDOM.findDOMNode(this.refs.privilegeAppAccessSection)
        this.privilegeApiAccessSection = ReactDOM.findDOMNode(this.refs.privilegeApiAccessSection)
        this.privilegeRemarksSection = ReactDOM.findDOMNode(this.refs.privilegeRemarksSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 150) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 120) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        inputName = inputName + "SelectedId"
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined) {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditPrivilegesReady(false))
    let data = {}

    let privilegeNameObject = this.mandateValidation("privilegeName", Constants.FORM_INPUT)
    if (privilegeNameObject.status) {
        data.name = this.privilegeNameComponent.value
    } else {

         this.props.dispatch(addEditPrivilegesReady(true))
        return
    }


    let privilegeApiAccessObject = this.mandateValidation("privilegeApiAccess", Constants.FORM_INPUT)
    if (privilegeApiAccessObject.status) {
        data.api_access = this.privilegeApiAccessComponent.value
    } else {
         this.props.dispatch(addEditPrivilegesReady(true))
        return
    }


     let privilegeAppAccessObject = this.mandateValidation("privilegeAppAccess", Constants.FORM_INPUT)
    if (privilegeAppAccessObject.status) {
        data.app_access = this.privilegeAppAccessComponent.value
    } else {
         this.props.dispatch(addEditPrivilegesReady(true))
        return
    }

    data.remarks = this.privilegeRemarksComponent.value

    


    data.roles = this.state.selectedRoles

    if(this.state.deletedRoles.length>0){
            data.roles=data.roles.concat(this.state.deletedRoles)
    }

    let apiPayloadData=data;


    if(this.state.editFlag){

       

        apiService.editPrivilege(apiPayloadData,this.state.privilegesData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditPrivilegesReady(true))
                        this.props.history.push("/dashboard/privileges/list")
                    } else {

                        this.props.dispatch(addEditPrivilegesReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditPrivilegesReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addPrivilege(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditPrivilegesReady(true))
                        this.props.history.push("/dashboard/privileges/list")
                    } else {

                        this.props.dispatch(addEditPrivilegesReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditPrivilegesReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}

getRolesComboList = () => {
    apiService.getRolesComboList()
        .then(responseData => {
            if (responseData) {

                if (responseData && responseData.data) {
                    let data = Object.entries(responseData.data);

                    this.setState({
                        rolesList: data
                    })



                    if(!this.state.editFlag){
                        this.renderSelectOption(data)
                        this.props.dispatch(addEditPrivilegesReady(true))
                    }else{
                         if (this.props.privileges && this.props.privileges.privilegeSelectedId && this.props.privileges.privilegeSelectedId !== null) {
                            this.getPrivilegesById(this.props.privileges.privilegeSelectedId)
                           
                        }
                    }            

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
            this.props.dispatch(addEditPrivilegesReady(true))
        })
}

getPrivilegesById = (id) => {
    apiService.getPrivilegesById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        privilegesData: responseData.data                       
                    })

                    if (this.isComponentStillMounted) {
                        this.privilegeNameComponent.value=responseData.data.name
                        this.privilegeApiAccessComponent.value=responseData.data.api_access
                        this.privilegeAppAccessComponent.value=responseData.data.app_access
                        this.privilegeRemarksComponent.value=responseData.data.remarks
                    }

                    this.filterData(responseData.data)              

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditPrivilegesReady(true))
        })
}


filterData = (data) => {

    if(data){

            let roleData=[]

            let role_privileges=data.role_privileges;

            for(let i=0;i<role_privileges.length;i++){
            
                let temp={}

                temp['role_privilege_id']=role_privileges[i].id;
                temp['role_id']=role_privileges[i].role_id;
                temp['role_name']=role_privileges[i].role.name;
                temp['scoped']=role_privileges[i].is_scoped

                 roleData.push(temp)
            }

            this.setState({
                selectedRoles: roleData
            });

            let rolesList = this.state.rolesList
            let selectedRoles = this.state.selectedRoles

            //let index = rolesList.indexOf(selectedValue);

            selectedRoles.map(function(item) {
                rolesList.map(function(item2,index) {
                    if (parseInt(item2[0],10) === item.role_id) {
                        if (index > -1) {
                            rolesList.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    }
                    return true
                });
                return true
            })



            this.setState({
                rolesList: rolesList
               }); 


        this.renderSelectOption(rolesList)
         this.props.dispatch(addEditPrivilegesReady(true))
    }
}



addRoleBtn = () => {

    let selectedValueId = document.getElementById("userRoleId").value;
    let selectedValueText = document.getElementById("userRoleId").options[document.getElementById("userRoleId").selectedIndex].text;
    let checkedValue = document.getElementById("checkbox_id").checked;
    let selectedRoles = this.state.selectedRoles;
    


    let deletedRoles = this.state.deletedRoles;

    if(this.state.editFlag){
        let index_d;
        let role_privilege_id;
         deletedRoles.map(function(item, index) {
            if (item['role_id'] === selectedValueId) {
                index_d = index
                role_privilege_id=item['role_privilege_id']
            }
            return true
        })

         selectedRoles.push({
            "role_privilege_id":role_privilege_id,
            "role_id": selectedValueId,
            "role_name": selectedValueText,
            "scoped": checkedValue
        });

        if (index_d > -1) {
            deletedRoles.splice(index_d, 1); // 2nd parameter means remove one item only
        }



    }else{

        selectedRoles.push({
            "role_id": selectedValueId,
            "role_name": selectedValueText,
            "scoped": checkedValue
        });
    }
    

    this.setState({
        selectedRoles: selectedRoles
    });


    let rolesList = this.state.rolesList

    //let index = rolesList.indexOf(selectedValue);
    let index_i;
    rolesList.map(function(item, index) {
        if (parseInt(item[0],10) === parseInt(selectedValueId,10)) {
            index_i = index
        }
        return true
    })

    if (index_i > -1) {
        rolesList.splice(index_i, 1); // 2nd parameter means remove one item only
    }

    this.setState({
        rolesList: rolesList
    });

    this.renderSelectOption(this.state.rolesList)
}


removeRole = (role_id) => {

    let selectedRoles = this.state.selectedRoles;
    let deletedRoles = this.state.deletedRoles;


    let index_i;
    let role_name;

    selectedRoles.map(function(item, index) {
        if (item['role_id'] === role_id) {
            index_i = index
            role_name = item['role_name']
        }
        return true
    })

    if(this.state.editFlag && selectedRoles[index_i]['role_privilege_id']){

        selectedRoles[index_i]['is_deleted']=1
        deletedRoles.push(selectedRoles[index_i])

        this.setState({
            deletedRoles: deletedRoles
        });
    }

    if (index_i > -1) {        
            selectedRoles.splice(index_i, 1);
    }

    this.setState({
        selectedRoles: selectedRoles
    });

    let rolesList = this.state.rolesList

    rolesList.push([role_id, role_name]);

    this.setState({
        rolesList: rolesList
    });

    this.renderSelectOption(this.state.rolesList)

}

renderSelectOption = (data) => {

    let privilegesList = data;
    let temp = '<select id="userRoleId" class="form-control">';
    for (let i = 0; i < privilegesList.length; i++) {
        temp += '<option value="' + privilegesList[i][0] + '">' + privilegesList[i][1] + '</option>';
    }
    temp += '</select>';
    let selectedElement = document.getElementById("selectIdRender");
    selectedElement.innerHTML = "";
    selectedElement.innerHTML = temp;


    //selectIdRender
}
   
checkBoxChange = (role_id,e) => {

    let selectedRoles = this.state.selectedRoles;

    selectedRoles.map(function(item, index) {
        if (item['role_id'] === role_id) {
            item.scoped = e.target.checked
        }
        return true
    })

     this.setState({
        selectedRoles: selectedRoles
    });

}


    render() {
        return (
            <div className="line-item-edit">

            <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.privilegeNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Privilege Name" type="text" ref={el => this.privilegeNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("privilegeName")}} />
                                                        <span className="help-block"style={{display: this.state.privilegeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.privilegeErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.privilegeApiAccessSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>API Access *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Privilege Api Access" type="text" ref={el => this.privilegeApiAccessComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("privilegeApiAccess")}} />
                                                        <span className="help-block"style={{display: this.state.privilegeApiAccessErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.privilegeApiAccessErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.privilegeAppAccessSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>APP Access *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Privilege App Access" type="text" ref={el => this.privilegeAppAccessComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("privilegeAppAccess")}} />
                                                        <span className="help-block"style={{display: this.state.privilegeAppAccessErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.privilegeAppAccessErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.privilegeRemarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.privilegeRemarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("privilegeRemarks")}} />
                                                        <span className="help-block"style={{display: this.state.privilegeRemarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.privilegeRemarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 

                                         <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">

                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select User Role*</label>
                                                    <div className="col-sm-9" id="selectIdRender">
                                                        <select id="userRoleId" className="form-control">
                                                          
                                                        </select>
                                                    </div>
                                                </div>

                                            
                                            </div>

                                            <div className="col-md-6 col-sm-12 col-xs-12">

                                             <div className="col-md-2">
                                                <div className="form-group">
                                                    <input className="checkbox" type="checkbox" name="checkbox" id="checkbox_id" value="value" style={{"float": "left"}}/>
                                                    <label for="checkbox_id" style={{"float": "left","margin": "4px 6px"}}>Scoped</label>

                                                    </div>
                                                </div>


                                             <div className="col-md-6">
                                                <div className="add-btn-box">
                                                     <button
                                                        className="btn btn-info"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.addRoleBtn()
                                                        }}>
                                                        Add
                                                    </button>
                                                </div>
                                                </div>

                                                </div>
                                            </div>                                       
                                        

                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>


                                        {(() => {

                                       if(this.state.selectedRoles.length>0){
                                                                        return (
                                        <div className="col-md-12">
                                        <div className="col-md-6">
                                         <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    <h4>Selected User Roles</h4>


                                        <table className="table table-bordered" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr><th>User</th><th>Scoped</th><th>Delete</th></tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.selectedRoles.map((item, index) => (

                                                        <tr><td>{this.state.selectedRoles[index].role_name}</td>
                                                        <td><input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.selectedRoles[index].scoped} 
                                                        onChange={(e) => {
                                                            this.checkBoxChange(this.state.selectedRoles[index].role_id,e)
                                                        }}
                                                        /></td>
                                                        <td>
                                                        <button
                                                        className="btn btn-danger"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.removeRole(this.state.selectedRoles[index].role_id)
                                                        }}>
                                                        X
                                                    </button></td>

                                                        </tr>

                                                        ))}
                                                        </tbody>

                                            </table>
                                            </div>
                                            </div>
                                            </div>
                                            </div>

                                            )
                                        }

                                         })()}


                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        privileges: state.privileges,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditPrivileges))


// WEBPACK FOOTER //
// ./src/modules/Privileges/Components/AddEditPrivileges.js